import {EVERYONE_ELSE_GROUP_ID, type ReviewerOption} from './reviewer-options'
import type {SelectPanelItemInput} from '@primer/react'
import {GitHubAvatar} from '@github-ui/github-avatar'
import styles from './ReviewerPicker.module.css'

/**
 * Maps a plain `ReviewerOption` to SelectPanel's item shape — the only JSX in
 * the picker. "Everyone else" rows wrap the name below the login when they no
 * longer fit side by side; suggestions surface their reason as a block description.
 */
export function toSelectPanelItem(option: ReviewerOption): SelectPanelItemInput {
  const {id, login, name, reason, avatarUrl, isTeam, group} = option
  const leadingVisual = () => <GitHubAvatar src={avatarUrl} size={16} square={isTeam} alt="" />

  if (group === EVERYONE_ELSE_GROUP_ID) {
    return {
      id,
      children: (
        <span className={styles.reviewerOption}>
          <span className={styles.reviewerOptionLogin}>{login}</span>
          {name ? <span className={styles.reviewerOptionName}>{name}</span> : null}
        </span>
      ),
      groupId: group,
      leadingVisual,
    }
  }

  return {
    id,
    children: (
      <>
        {login}
        {name ? <span className={styles.inlineSubtleName}>{name}</span> : null}
      </>
    ),
    description: reason || undefined,
    descriptionVariant: 'block',
    groupId: group,
    leadingVisual,
  }
}
